import { render } from "./AssignEmployeeSalaries.vue?vue&type=template&id=31049105&scoped=true"
import script from "./AssignEmployeeSalaries.vue?vue&type=script&lang=js"
export * from "./AssignEmployeeSalaries.vue?vue&type=script&lang=js"

import "./AssignEmployeeSalaries.vue?vue&type=style&index=0&id=31049105&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31049105"]])

export default __exports__